import * as yup from "yup";
import { isNumber } from "../../utils/utils";

export function getSchema(
  purchasePriceRangeFrom: number,
  purchasePriceRangeTo: number,
  downPaymentRangeFrom: number,
  downPaymentRangeTo: number,
  residualValueRangeFrom: number,
  residualValueRangeTo: number
) {
  return yup.object().shape({
    purchasePrice: yup
      .number()
      .transform((value) => (isNaN(value) ? null : value))
      .required("error_purchasepriceexclvatmissing")
      .positive("error_purchasepriceexclvatmin")
      .min(purchasePriceRangeFrom, "error_purchasepriceexclvatmin")
      .max(purchasePriceRangeTo, "error_purchasepriceexclvatmax"),
    downPayment: yup
      .number()
      .transform((value) => (isNaN(value) ? null : value))
      .required("error_downpaymentmissing")
      .test("min", "error_downpaymentmin", function minTest(value) {
        const { purchasePrice } = this.parent;
        if (isNumber(value) && isNumber(purchasePrice) && purchasePrice >= purchasePriceRangeFrom && purchasePrice <= purchasePriceRangeTo) {
          return value >= (purchasePrice * downPaymentRangeFrom) / 100;
        }
        return true;
      })
      .test("max", "error_downpaymentmax", function maxTest(value) {
        const { purchasePrice } = this.parent;
        if (isNumber(value) && isNumber(purchasePrice) && purchasePrice >= purchasePriceRangeFrom && purchasePrice <= purchasePriceRangeTo) {
          return value <= (purchasePrice * downPaymentRangeTo) / 100;
        }
        return true;
      }),
    contractPeriodInMonths: yup.number().required("error_contractperiodinmonthsmissing"),
    residualValuePercentage: yup
      .number()
      .required("error_residualvaluemissing")
      .min(residualValueRangeFrom, "error_residualvaluechange")
      .max(residualValueRangeTo, "error_residualvaluechange"),
  });
}
